import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ContentService } from '@reusable/services/common/content.service';
import * as globals from '@reusable/services/globals';

@Component({
  selector: 'app-shared-footer',
  standalone: false,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']

})
export class FooterComponent implements OnInit, OnChanges {
  @Input() carData;
  pageBottom: boolean = true;
  hostUrl = window.location.host.split('.');
  subdomain = this.hostUrl[0];
  isSubdomain: boolean = false;
  manufactureList: any[];
  modelsList = [];
  queryOptions: any = {
    sortBy: 'order',
    records: null,
    pageNumber: 1
  };
  _carData: any;
  subdomainCars: any = [{ modelsIds: [{ nameArabic: '' }], nameArabic: '' }];
  appURL: any;
  constructor(private content: ContentService) {}

  ngOnInit() {
    this.appURL = globals.appURL;
    if (this.hostUrl.length === 3 && this.subdomain !== 'www' && this.subdomain !== '') {
      this.isSubdomain = true;
      this.loadManufactures();
    }
    this.loadManufactures();
    if (this.carData) {
      this._carData = this.carData;
    }
  }
  ngOnChanges() {
    if (this.carData) {
      this._carData = this.carData;
    }
  }

  loadManufactures() {
    this.content
      .getManufactures(this.queryOptions.sortBy, this.queryOptions.records, this.queryOptions.pageNumber, {
        isDeleted: false,
        showInFooter: true,
        modelsSortBy: 'order'
      })
      .subscribe((data) => {
        if (data.case === 1) {
          this.manufactureList = data.manufs;
          if (this._carData) {
            for (let i = 0; i < data.manufs.length; i++) {
              if (this._carData.models[0].manufactureId._id === data.manufs[i]._id) {
                this.subdomainCars = data.manufs[i];
              }
            }
          }
        }
      });
  }
}